import {Loader} from 'google-maps';
import {on_window_load, array_each} from 'lib/utilities';
import MAP_STYLES from 'app/init-map/styles';

export default async function init_map() {
    await on_window_load();

    const maps = document.querySelectorAll<HTMLElement>('.google-map');

    if (maps.length === 0) {
        return;
    }

    const google = await load_maps();

    array_each(maps, element => {
        const lat = parseFloat(element.dataset.lat || '0');
        const lng = parseFloat(element.dataset.lng || '0');
        const zoom = parseInt(element.dataset.zoom || '12');
        const markers = JSON.parse(element.dataset.markers || '[]');

        const map = new google.maps.Map(element, {
            zoom,
            center: {lat, lng},
            styles: MAP_STYLES as []
        });

        markers.forEach(({lat, lng}) => {
            const width = 419;
            const height = 567;
            const sHeight = 96;
            const sWidth = width / height * sHeight;

            const marker = new google.maps.Marker({
                map,
                position: {
                    lat: parseFloat(lat),
                    lng: parseFloat(lng)
                },
                icon: {
                    url: window._TEMPLATES_URL + '/svg/map-pin-3.svg',
                    size: new google.maps.Size(width, height),
                    origin: new google.maps.Point(0, 0),
                    anchor: new google.maps.Point(sWidth / 2, sHeight),
                    scaledSize: new google.maps.Size(sWidth, sHeight)
                }
            });

            marker.setMap(map);
        })
    })
}

async function load_maps() {
    const loader = new Loader(window._GOOGLE_MAPS_API_KEY, {
        version: 'quarterly'
    });

    return await loader.load();
}